import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { commonPropTypes } from "./entities-selector";
import SelectComponent from "./SelectComponent";
import { getAssetCategoriesService, getAssetsByCustomer } from "../../services/commonService";
import { LARGE_SELECT_LIMIT } from "./utils/select-constants";
import { useAssetApiSelectContext } from "./asset-select-context";

const AssetSelect = ({
  multiple,
  value,
  name,
  label,
  id,
  handleChange,
  disabled = false,
  handleClick,
  customerId,
  filterCategories,
  variables,
  excluded = [],
}) => {
  const [displayedAssets, setDisplayedAssets] = useState([]);
  const context = useAssetApiSelectContext();

  const assetsCallback = data => {
    const filteredAssets = excluded?.length ? data.filter(asset => !excluded.includes(asset._id)) : data;
    setDisplayedAssets(filteredAssets);
  };

  const getAssets = () => {
    getAssetsByCustomer(customerId, { ...variables, limit: LARGE_SELECT_LIMIT }, assetsCallback);
  };

  const assetCategoriesCallback = data => {
    const categoryIds = data
      .filter(category => filterCategories.includes(category.codename))
      .map(category => category._id);

    getAssetsByCustomer(
      customerId,
      { ...variables, category_ids: categoryIds, limit: LARGE_SELECT_LIMIT },
      assetsCallback,
    );
  };

  const getAssetCategories = useCallback(() => {
    getAssetCategoriesService(assetCategoriesCallback);
  }, []);

  useEffect(
    () => {
      if (context) {
        context.fetchAssets(customerId, filterCategories, variables, assetsCallback);
      } else {
        if (!!filterCategories?.length) {
          getAssetCategories();
        } else {
          getAssets();
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [customerId, filterCategories, JSON.stringify(variables), context],
  );

  return (
    <SelectComponent
      disabled={disabled}
      name={name}
      multiple={multiple}
      label={label}
      id={id}
      value={value}
      handleChange={handleChange}
      elements={displayedAssets}
      getValueFromElement={item => item._id}
      getLabelFromElement={item => item.codename}
      itemKey="_id"
      itemValue="_id"
      itemLabel="codename"
      handleClick={handleClick}
    />
  );
};

AssetSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del selector
   */
  selectedElement: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Valor del selector
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Valor del texto de la opción vacía, si existe (opcional)
   */
  emptyValueText: PropTypes.string,
  /**
   * Array de IDs de assets a excluir de la lista
   */
  excluded: PropTypes.arrayOf(PropTypes.string),
};

export default AssetSelect;
